import config from '../config';

const fetch = require('isomorphic-fetch');

const baseURL = __CLIENT__ ? '/api' : config.apiPath;

export function upload(file, type, isPublic = false) {
  return fetch(`${baseURL}/files/upload/${type}?filename=${file.name}&public=${isPublic}`, {
    method: 'GET',
    credentials: 'include'
  })
    .then(res => res.json())
    .then((data) => {
      const formData = new FormData();
      Object.keys(data.params).forEach((key) => {
        formData.append(key, data.params[key]);
      });
      formData.append('file', file);
      return fetch(data.form_url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
        header: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        if (res.ok) return Promise.resolve(data.params.key);
        return Promise.reject(res);
      });
    });
}

export function path(image, preset = 'thumbnail', style = false, noWatermark = false) {
  const presets = {
    thumbnail: 'w400-h300-cfill-q80',
    listingThumbnail: 'w580-h580-cfill-q80',
    profileAvatar: 'w340-h340-cfill-q80',
    reviewAvatar: 'w100-h100-cfill-q80',
    reviewAvatar2x: 'w200-h200-cfill-q80',
    profileCover: 'w2600-h800-cfill',
    tripCover: 'w1200-h900-cfill',
    tripCoverNew: 'w1168-h656-cfill',
    tripCoverIphone: 'w1200-h900-cfill',
    tripCoverMobile: 'w600-h450-cfill',
    avatarNavMini: 'w74-h74-cfill',
    avatarNavMini2x: 'w148-h148-cfill',
    avatarReviewCard: 'w140-h140-cfill-q80',
    avatarReviewCard2x: 'w280-h280-cfill-q80',
    coverTripCard: 'w360-h360-cfill-q80',
    coverTripCard2x: 'w720-h720-cfill-q80',
    avatarTripCard: 'w46-h46-cfill',
    avatarTripCard2x: 'w92-h92-cfill',
    featureCover: 'w800-h370-cfill-q80',
    featureCover2x: 'w1600-h740-cfill-q80',
    imageTopic: 'w800-cfill-q80',
    imageTopic2x: 'w1600-cfill-q80',
    inspCol1: 'w660-h440-cfill-q80',
    inspCol2: 'w1320-h440-cfill-q80',
    gallery: 'w2560-q80',
    reviewGallery: 'w1200-h675-q80',
    mobileGallery: 'w1280-q80',
    modalImage: 'w500-h500-q80',
    profileNoti: 'w40-h40',
    'square-300': 'w600-h600-cfill-q80',
    'square-230': 'w230-h230-cfill-q80',
    'square-460': 'w460-h460-cfill-q80',
    'rectangle-800-600': 'w666-h500-cfill-q80',
    'rectangle-600-600': 'w600-h600-cfill-q80',
    'rectangle-400-300': 'w400-h300-cfill-q80',
    'rectangle-300-400': 'w300-h400-cfill-q80',
    'rectangle-600-800': 'w600-h800-cfill-q80',
    'rectangle-310-233': 'w310-h233-cfill-q80',
    'rectangle-620-466': 'w620-h466-cfill-q80',
    tripCardLowRes: 'w31-h23-cfill-q50',
    lxCardCover: 'w620-h300-cfill-q80',
    lxCardAvatar: 'w84-h84-cfill-q80',
    lxCardAvatar2x: 'w168-h168-cfill-q80',
    imagesThumbnail: 'w315-h220-cfill-q80',
    imagesThumbnail2x: 'w630-h440-cfill-q80',
    similarTripCover: 'w310-h200-cfill-q80',
    similarTripAvatar: 'w28-h28-cfill-q80',
    lxAvatar: 'w160-h160-cfill-q80',
    lxAvatar2x: 'w320-h320-cfill-q80',
    articleCover: 'w1200-h500-cfill-q80',
    articleCoverMobile: 'w800-h450-cfill-q80',
    articleImage: 'w800-h600-cfill-q80',
    articleImage2x: 'w1600-h1200-cfill-q80',
    articleThumbnailCover: 'w600-h300-cfill-q80',
    fullSize: '',
    hd: 'w1280-h720-cfill-q80',
    masterGalleryCard: 'w348-h435-cfill-q80',
  };
  const url = `${config.mediaPath}/${presets[preset].length > 0 ? `${presets[preset]}/` : ''}${encodeURI(image)}${noWatermark ? '?noMark=true' : ''}`
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29');
  if (style) {
    return { backgroundImage: `url('${url}')` };
  }
  return url;
}

export function defaultAvatarImage(text, isRetina = false) {
  return `${config.uiKitAssetPath}/images/default/${(text || 'T')[0].toUpperCase()}${isRetina ? '@2x' : ''}.jpg`;
}
